import React from 'react';
import { Wrapper } from './styled';
import Header from '../Header';
import Footer from '../Footer';

const Layout = ({ children, display }) => {
	return (
		<Wrapper>
			<Header />
			{children}
			<Footer />
		</Wrapper>
	);
};

export default Layout;
